import { render, staticRenderFns } from "./InboundBatchList.template.vue?vue&type=template&id=03c5a83a&scoped=true&"
var script = {}
import style0 from "./InboundBatchList.template.vue?vue&type=style&index=0&id=03c5a83a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5a83a",
  null
  
)

export default component.exports